import { useEffect, useState } from 'react';
import { GrantTypeModel } from '../../../../api-service/clients';
import { moduleClientFactory } from '../../../../api-service/module-client-factory';

const grantClient = moduleClientFactory.createCitizenGrantClient();

export function useGetGrantTypes() {
  const [grantTypes, setGrantTypes] = useState<GrantTypeModel[]>([]);

  useEffect(() => {
    async function loadGrantTypes() {
      const grantResponse = await grantClient.getGrantTypes();
      const sortedGrantTypes = (grantResponse.grantTypes || []).sort((a, b) => (a.name?.toLowerCase() || '').localeCompare(b.name?.toLowerCase() || ''));
      setGrantTypes(sortedGrantTypes);
    }
    loadGrantTypes();
  }, []);

  return grantTypes;
}
